import { createFileRoute } from "@tanstack/react-router";
import { CreateInvitationPage } from "@/components/pages/CreateInvitationPage";

export const Route = createFileRoute("/invitations/create")({
  component: CreateInvitationPage,
});
